import React, { useEffect, useState } from "react";
// hook
import { useProductosInsumos } from "../../../../hooks/useProductosInsumos.js";
// servicio aplicacion
import { capitalizar } from "../../../../../utils/capitalizar.js";
import { formatearPrecio } from  "../../../../../utils/precios.js";
// Componentes
import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";
import TablaDetalleCompuesto from "../datalle/tablaDetalles.js";
import TablaGenerica from "../../../../componentsUI/tablas/tablaGenerica.js";

export default function ListaItemsCompuesto({ rowsPerPage = 8 }) {
  // data desde hook
  const { productosBom, cargarProductosBom } = useProductosInsumos();
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  // activar datos
  useEffect(() => {
    cargarProductosBom();
  }, [cargarProductosBom]);

  // variable interna
  const seleccionarProducto = (codigo) => {
    const grupo = productosBom.filter((item) => item.Codigo === codigo);

    console.log("Código clic:", codigo);
    console.log("Grupo encontrado:", grupo);
    console.log("Cantidad de filas:", grupo.length);

    setProductoSeleccionado(grupo);
  };

  return (
    <div className="contenedor-tabla-modulos">
      <TituloModulo titulo="Productos e Insumos" />

      <div className="contenedor-grupo">
        <BotonAccion onClick={cargarProductosBom}>
          {" "}
          Cargar Productos
        </BotonAccion>
      </div>

      <TablaGenerica
        titulo="Lista de productos compuestos"
        headers={["Producto", "Insumo", "Categoría", "Precio"]}
        data={productosBom}
        rowsPerPage={rowsPerPage}
        renderRow={(row, index) => (
          <tr
            key={`${row.Codigo}-${row.id_bom ?? index}`}
            onClick={() => seleccionarProducto(row.Codigo)}
            style={{ cursor: "pointer" }}
          >
            <td className="col-1">
              {row.producto_insumo} - {capitalizar(row.nombre)}
            </td>

            <td className="col-2">
              {row.Codigo} - {capitalizar(row.nombre_insumo)}
            </td>

            <td className="col-3">{capitalizar(row.categoria)}</td>

            <td className="col-4">
              {row.precio_unitario && formatearPrecio(row.precio_unitario)}
            </td>
          </tr>
        )}
      />

      <TablaDetalleCompuesto className="tabla-cambios" productoSeleccionado={productoSeleccionado} />
    </div>
  );
}
